import './App.css';
import {BrowserRouter as Router, Routes, Route} from 
'react-router-dom';
import Home from './components/pages/Home';
import Account from './Account/Acount';


function App() {
  return (

    <>
      <Router>
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/about#about" element={<Home />} />
          <Route path="/account" element={<Account />} />
        </Routes>
      </Router>


    </>
  );
}

export default App;
